import Box from "@/common/components/Box";
import DropdownMenu from "@/common/components/DropdownMenu";
import ResumeItem from "@/common/components/ResumeItem";
import { formatDateTime } from "@/common/utils/formatters";
import { billingFiscalDocumentsStatus } from "@/features/billingBills/constants/billFiscalDocumentsStatus.constant";
import { FiscalDocumentData } from "@/features/billingBills/types/fiscalDocument.type";

interface MainFiscalDocumentProps {
  fiscalDocument: FiscalDocumentData;
}

const MainFiscalDocument = ({ fiscalDocument }: MainFiscalDocumentProps) => {
  return (
    <Box className="p-4 flex items-center justify-between" data-testid="main_fiscal_document">
      <div className="flex items-center gap-3">
        <ResumeItem
          label="Serial da nota"
          value={fiscalDocument.serial || '--'}
        />

        <ResumeItem
          label="Status no Sicof"
          value={(
            fiscalDocument.status &&
            billingFiscalDocumentsStatus[fiscalDocument.status as keyof typeof billingFiscalDocumentsStatus]
          ) || '--'}
        />

        <ResumeItem
          label="Data/Hora de envio ao Sicof"
          value={fiscalDocument.issued_at ? formatDateTime(new Date(fiscalDocument.issued_at)) : '--'}
        />

        <ResumeItem
          label="Data/Hora do último retorno do Sicof"
          value={fiscalDocument.confirmed_at ? formatDateTime(new Date(fiscalDocument.confirmed_at)) : '--'}
        />
      </div>

      <div className="flex items-center gap-3">
        <DropdownMenu
          triggerLabel="Baixar nota"
          options={[
            {
              label: 'PDF',
              onClick: () => fiscalDocument?.pdf?.url && window.open(fiscalDocument?.pdf?.url, '_blank'),
              disabled: !fiscalDocument?.pdf?.url,
            },
            {
              label: 'XML',
              onClick: () => fiscalDocument?.xml?.url && window.open(fiscalDocument?.xml?.url, '_blank'),
              disabled: !fiscalDocument?.xml?.url,
            },
          ]}
        />
      </div>
    </Box>
  );
}

export default MainFiscalDocument;
